export const GROWTH_RANGE = 360;
export const CHART_RANGE = 360;
